import { AlertSummary } from "../components/AlertSummary/AlertSummary";

export const PageNotFoundPage = () => {
  return (
    <div className="mx-auto w-full pt-4 px-10">
      <AlertSummary title="Sorry, that page cannot be found" />
    </div>
  );
};
